import { apiClient } from './client'

const queryString = (params = {}) => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    query.set(key, String(value))
  })
  return query.toString()
}

export async function fetchRezervaceCalendar({ od, do: datumDo } = {}) {
  const query = queryString({ od, do: datumDo })
  return apiClient.get(query ? `/rezervace?${query}` : '/rezervace')
}

export async function searchRezervace(filters = {}) {
  const query = queryString(filters)
  return apiClient.get(query ? `/rezervace/hledat?${query}` : '/rezervace/hledat')
}

export async function fetchRezervaceDetail(id) {
  return apiClient.get(`/rezervace/detail/${id}`)
}

export async function fetchRezervaceHistorie(id) {
  return apiClient.get(`/rezervace/${id}/historie`)
}

export async function fetchRezervaceCiselniky() {
  return apiClient.get('/rezervace/ciselniky')
}

export async function createRezervace(payload) {
  return apiClient.post('/rezervace', payload)
}

export async function updateRezervace(id, payload) {
  return apiClient.put(`/rezervace/${id}`, payload)
}

export async function moveRezervace(id, payload) {
  return apiClient.put(`/rezervace/presun/${id}`, payload)
}

export async function updateRezervaceStav(id, stav) {
  return apiClient.patch(`/rezervace/${id}/stav`, { stav })
}

export async function sendRezervaceEmail(id) {
  return apiClient.post(`/rezervace/${id}/email/send`)
}

export async function sendRezervaceSms(id) {
  return apiClient.post(`/rezervace/${id}/sms/send`)
}

export async function deleteRezervace(id) {
  return apiClient.del(`/rezervace/${id}`)
}
